import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import Alert from '../../../common/base/Alert';
import Button from '../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../common/base/Card';
import Container from '../../../common/base/Container';
import Text from '../../../common/base/Text';
import SelectInput from '../../../common/Form/Fields/SelectInput';
import SwitchInput from '../../../common/Form/Fields/SwitchInput';
import TextInput from '../../../common/Form/Fields/TextInput';
import { Div } from '../../../common/helpers/StyledUtils';
import { useOutpostConfigUpdate } from '../OutpostContext';
import { OperatorConfig, OperatorConfigUpdateInput } from '../../../../../../../typings/OutpostDeployment.interface';
type Provider = 'aws_sqs' | 'azure_servicebus' | 'gcp_pubsub' | 'rabbitmq';
const detectProvider = (config: OperatorConfig): Provider | null => {
  if (config.PUBLISH_AWS_SQS_QUEUE || config.PUBLISH_AWS_SQS_ACCESS_KEY_ID) return 'aws_sqs';
  if (config.PUBLISH_AZURE_SERVICEBUS_TOPIC || config.PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING) return 'azure_servicebus';
  if (config.PUBLISH_GCP_PUBSUB_TOPIC || config.PUBLISH_GCP_PUBSUB_PROJECT) return 'gcp_pubsub';
  if (config.PUBLISH_RABBITMQ_QUEUE || config.PUBLISH_RABBITMQ_SERVER_URL) return 'rabbitmq';
  return null;
};
const PUBLISH_KEYS = ['PUBLISH_AWS_SQS_ACCESS_KEY_ID', 'PUBLISH_AWS_SQS_SECRET_ACCESS_KEY', 'PUBLISH_AWS_SQS_REGION', 'PUBLISH_AWS_SQS_ENDPOINT', 'PUBLISH_AWS_SQS_QUEUE', 'PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING', 'PUBLISH_AZURE_SERVICEBUS_TOPIC', 'PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION', 'PUBLISH_GCP_PUBSUB_PROJECT', 'PUBLISH_GCP_PUBSUB_TOPIC', 'PUBLISH_GCP_PUBSUB_SUBSCRIPTION', 'PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS', 'PUBLISH_RABBITMQ_SERVER_URL', 'PUBLISH_RABBITMQ_EXCHANGE', 'PUBLISH_RABBITMQ_QUEUE'] as const;
const getConfigWithClearedPublishKeys = (): OperatorConfigUpdateInput => {
  const updated: OperatorConfigUpdateInput = {};
  for (const key of PUBLISH_KEYS) {
    // null clears the override (no cloud defaults for PUBLISH_* keys)
    updated[key] = null;
  }
  return updated;
};
const PublishingSettings = () => {
  const $ = _c(28);
  const {
    config,
    updateConfig
  } = useOutpostConfigUpdate();
  let t0;
  if ($[0] !== config) {
    t0 = detectProvider(config);
    $[0] = config;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const current_provider = t0;
  const t1 = current_provider !== null;
  const t2 = current_provider || "aws_sqs" as Provider;
  const t3 = config.PUBLISH_AWS_SQS_ACCESS_KEY_ID ?? "";
  const t4 = config.PUBLISH_AWS_SQS_SECRET_ACCESS_KEY ?? "";
  const t5 = config.PUBLISH_AWS_SQS_REGION ?? "";
  const t6 = config.PUBLISH_AWS_SQS_ENDPOINT ?? "";
  const t7 = config.PUBLISH_AWS_SQS_QUEUE ?? "";
  const t8 = config.PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING ?? "";
  const t9 = config.PUBLISH_AZURE_SERVICEBUS_TOPIC ?? "";
  const t10 = config.PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION ?? "";
  const t11 = config.PUBLISH_GCP_PUBSUB_PROJECT ?? "";
  const t12 = config.PUBLISH_GCP_PUBSUB_TOPIC ?? "";
  const t13 = config.PUBLISH_GCP_PUBSUB_SUBSCRIPTION ?? "";
  const t14 = config.PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS ?? "";
  const t15 = config.PUBLISH_RABBITMQ_SERVER_URL ?? "";
  const t16 = config.PUBLISH_RABBITMQ_EXCHANGE ?? "";
  const t17 = config.PUBLISH_RABBITMQ_QUEUE ?? "";
  let t18;
  if ($[2] !== t1 || $[3] !== t10 || $[4] !== t11 || $[5] !== t12 || $[6] !== t13 || $[7] !== t14 || $[8] !== t15 || $[9] !== t16 || $[10] !== t17 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t18 = {
      enabled: t1,
      provider: t2,
      PUBLISH_AWS_SQS_ACCESS_KEY_ID: t3,
      PUBLISH_AWS_SQS_SECRET_ACCESS_KEY: t4,
      PUBLISH_AWS_SQS_REGION: t5,
      PUBLISH_AWS_SQS_ENDPOINT: t6,
      PUBLISH_AWS_SQS_QUEUE: t7,
      PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING: t8,
      PUBLISH_AZURE_SERVICEBUS_TOPIC: t9,
      PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION: t10,
      PUBLISH_GCP_PUBSUB_PROJECT: t11,
      PUBLISH_GCP_PUBSUB_TOPIC: t12,
      PUBLISH_GCP_PUBSUB_SUBSCRIPTION: t13,
      PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS: t14,
      PUBLISH_RABBITMQ_SERVER_URL: t15,
      PUBLISH_RABBITMQ_EXCHANGE: t16,
      PUBLISH_RABBITMQ_QUEUE: t17
    };
    $[2] = t1;
    $[3] = t10;
    $[4] = t11;
    $[5] = t12;
    $[6] = t13;
    $[7] = t14;
    $[8] = t15;
    $[9] = t16;
    $[10] = t17;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[20] !== updateConfig) {
    t19 = async (values, t20) => {
      const {
        resetForm
      } = t20;
      const updated_config = getConfigWithClearedPublishKeys();
      if (values.enabled) {
        if (values.provider === "aws_sqs") {
          if (values.PUBLISH_AWS_SQS_ACCESS_KEY_ID) {
            updated_config.PUBLISH_AWS_SQS_ACCESS_KEY_ID = values.PUBLISH_AWS_SQS_ACCESS_KEY_ID;
          }
          if (values.PUBLISH_AWS_SQS_SECRET_ACCESS_KEY) {
            updated_config.PUBLISH_AWS_SQS_SECRET_ACCESS_KEY = values.PUBLISH_AWS_SQS_SECRET_ACCESS_KEY;
          }
          if (values.PUBLISH_AWS_SQS_REGION) {
            updated_config.PUBLISH_AWS_SQS_REGION = values.PUBLISH_AWS_SQS_REGION;
          }
          if (values.PUBLISH_AWS_SQS_ENDPOINT) {
            updated_config.PUBLISH_AWS_SQS_ENDPOINT = values.PUBLISH_AWS_SQS_ENDPOINT;
          }
          if (values.PUBLISH_AWS_SQS_QUEUE) {
            updated_config.PUBLISH_AWS_SQS_QUEUE = values.PUBLISH_AWS_SQS_QUEUE;
          }
        } else {
          if (values.provider === "azure_servicebus") {
            if (values.PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING) {
              updated_config.PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING = values.PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING;
            }
            if (values.PUBLISH_AZURE_SERVICEBUS_TOPIC) {
              updated_config.PUBLISH_AZURE_SERVICEBUS_TOPIC = values.PUBLISH_AZURE_SERVICEBUS_TOPIC;
            }
            if (values.PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION) {
              updated_config.PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION = values.PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION;
            }
          } else {
            if (values.provider === "gcp_pubsub") {
              if (values.PUBLISH_GCP_PUBSUB_PROJECT) {
                updated_config.PUBLISH_GCP_PUBSUB_PROJECT = values.PUBLISH_GCP_PUBSUB_PROJECT;
              }
              if (values.PUBLISH_GCP_PUBSUB_TOPIC) {
                updated_config.PUBLISH_GCP_PUBSUB_TOPIC = values.PUBLISH_GCP_PUBSUB_TOPIC;
              }
              if (values.PUBLISH_GCP_PUBSUB_SUBSCRIPTION) {
                updated_config.PUBLISH_GCP_PUBSUB_SUBSCRIPTION = values.PUBLISH_GCP_PUBSUB_SUBSCRIPTION;
              }
              if (values.PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS) {
                updated_config.PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS = values.PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS;
              }
            } else {
              if (values.provider === "rabbitmq") {
                if (values.PUBLISH_RABBITMQ_SERVER_URL) {
                  updated_config.PUBLISH_RABBITMQ_SERVER_URL = values.PUBLISH_RABBITMQ_SERVER_URL;
                }
                if (values.PUBLISH_RABBITMQ_EXCHANGE) {
                  updated_config.PUBLISH_RABBITMQ_EXCHANGE = values.PUBLISH_RABBITMQ_EXCHANGE;
                }
                if (values.PUBLISH_RABBITMQ_QUEUE) {
                  updated_config.PUBLISH_RABBITMQ_QUEUE = values.PUBLISH_RABBITMQ_QUEUE;
                }
              }
            }
          }
        }
      }
      const result = await updateConfig(updated_config, {
        success: "Publishing settings updated",
        failure: "Failed to update publishing settings",
        labels: {
          PUBLISH_AWS_SQS_ACCESS_KEY_ID: "Access Key ID",
          PUBLISH_AWS_SQS_SECRET_ACCESS_KEY: "Secret Access Key",
          PUBLISH_AWS_SQS_REGION: "Region",
          PUBLISH_AWS_SQS_ENDPOINT: "Endpoint",
          PUBLISH_AWS_SQS_QUEUE: "Queue",
          PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING: "Connection String",
          PUBLISH_AZURE_SERVICEBUS_TOPIC: "Topic",
          PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION: "Topic Subscription",
          PUBLISH_GCP_PUBSUB_PROJECT: "Project",
          PUBLISH_GCP_PUBSUB_TOPIC: "Topic",
          PUBLISH_GCP_PUBSUB_SUBSCRIPTION: "Subscription",
          PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS: "Service Account Credentials",
          PUBLISH_RABBITMQ_SERVER_URL: "Server URL",
          PUBLISH_RABBITMQ_EXCHANGE: "Exchange",
          PUBLISH_RABBITMQ_QUEUE: "Queue"
        }
      });
      if (!result) {
        return;
      }
      const result_provider = detectProvider(result);
      resetForm({
        values: {
          enabled: result_provider !== null,
          provider: result_provider || "aws_sqs" as Provider,
          PUBLISH_AWS_SQS_ACCESS_KEY_ID: result.PUBLISH_AWS_SQS_ACCESS_KEY_ID ?? "",
          PUBLISH_AWS_SQS_SECRET_ACCESS_KEY: result.PUBLISH_AWS_SQS_SECRET_ACCESS_KEY ?? "",
          PUBLISH_AWS_SQS_REGION: result.PUBLISH_AWS_SQS_REGION ?? "",
          PUBLISH_AWS_SQS_ENDPOINT: result.PUBLISH_AWS_SQS_ENDPOINT ?? "",
          PUBLISH_AWS_SQS_QUEUE: result.PUBLISH_AWS_SQS_QUEUE ?? "",
          PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING: result.PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING ?? "",
          PUBLISH_AZURE_SERVICEBUS_TOPIC: result.PUBLISH_AZURE_SERVICEBUS_TOPIC ?? "",
          PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION: result.PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION ?? "",
          PUBLISH_GCP_PUBSUB_PROJECT: result.PUBLISH_GCP_PUBSUB_PROJECT ?? "",
          PUBLISH_GCP_PUBSUB_TOPIC: result.PUBLISH_GCP_PUBSUB_TOPIC ?? "",
          PUBLISH_GCP_PUBSUB_SUBSCRIPTION: result.PUBLISH_GCP_PUBSUB_SUBSCRIPTION ?? "",
          PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS: result.PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS ?? "",
          PUBLISH_RABBITMQ_SERVER_URL: result.PUBLISH_RABBITMQ_SERVER_URL ?? "",
          PUBLISH_RABBITMQ_EXCHANGE: result.PUBLISH_RABBITMQ_EXCHANGE ?? "",
          PUBLISH_RABBITMQ_QUEUE: result.PUBLISH_RABBITMQ_QUEUE ?? ""
        }
      });
    };
    $[20] = updateConfig;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== current_provider) {
    t20 = props => {
      const switching_provider = current_provider !== null && props.values.enabled && props.values.provider !== current_provider;
      return <Form><Text bold={true} size="l" as="h2" m={{
          t: 0,
          b: 0
        }}>Publishing Events</Text><Text m={{
          b: 4
        }} muted={true}>Publish events via the Outpost API or configure a message queue to ingest events from.</Text><StyledCard><StyledCardSection flex={{
            justify: "flex-start",
            align: "center",
            gap: 3
          }} p={{
            x: 4,
            y: 3
          }}><SwitchInput name="enabled" /><Text>Publish events via a message queue</Text></StyledCardSection></StyledCard>{props.values.enabled && <><SelectInput m={{
            y: 4
          }} block={true} name="provider" label="Message queue provider" options={[{
            value: "aws_sqs",
            label: "AWS SQS",
            icon: "awssqs"
          }, {
            value: "azure_servicebus",
            label: "Azure Service Bus",
            icon: "azure_servicebus"
          }, {
            value: "gcp_pubsub",
            label: "GCP Pub/Sub",
            icon: "gcp_pubsub"
          }, {
            value: "rabbitmq",
            label: "RabbitMQ",
            icon: "rabbitmq"
          }]} />{switching_provider && <Alert warning={true} inline={true} m={{
            b: 4
          }}>Switching providers will clear the current provider configuration.</Alert>}{props.values.provider === "aws_sqs" && <Div><TextInput name="PUBLISH_AWS_SQS_ACCESS_KEY_ID" label="Access Key ID" placeholder="AKIAIOSFODNN7EXAMPLE" /><TextInput name="PUBLISH_AWS_SQS_SECRET_ACCESS_KEY" label="Secret Access Key" type="password" placeholder={"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"} /><TextInput name="PUBLISH_AWS_SQS_REGION" label="Region" placeholder="us-east-1" /><TextInput name="PUBLISH_AWS_SQS_ENDPOINT" label="Endpoint (optional)" help="Custom endpoint URL for SQS-compatible services" placeholder="https://sqs.us-east-1.amazonaws.com" /><TextInput m={0} name="PUBLISH_AWS_SQS_QUEUE" label="Queue" placeholder="outpost-events" /></Div>}{props.values.provider === "azure_servicebus" && <Div><TextInput name="PUBLISH_AZURE_SERVICEBUS_CONNECTION_STRING" label="Connection String" type="password" placeholder={"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"} /><TextInput name="PUBLISH_AZURE_SERVICEBUS_TOPIC" label="Topic" placeholder="outpost-events" /><TextInput m={0} name="PUBLISH_AZURE_SERVICEBUS_SUBSCRIPTION" label="Topic Subscription" placeholder="outpost-sub" help="The name of a subscription on the topic above, not your Azure subscription ID" /></Div>}{props.values.provider === "gcp_pubsub" && <Div><TextInput name="PUBLISH_GCP_PUBSUB_PROJECT" label="Project" placeholder="my-gcp-project" /><TextInput name="PUBLISH_GCP_PUBSUB_TOPIC" label="Topic" placeholder="outpost-events" /><TextInput name="PUBLISH_GCP_PUBSUB_SUBSCRIPTION" label="Subscription" placeholder="outpost-sub" /><TextInput m={0} name="PUBLISH_GCP_PUBSUB_SERVICE_ACCOUNT_CREDENTIALS" label="Service Account Credentials (JSON)" type="password" placeholder={"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"} help="Paste the full JSON service account key" /></Div>}{props.values.provider === "rabbitmq" && <Div><TextInput name="PUBLISH_RABBITMQ_SERVER_URL" label="Server URL" type="password" placeholder={"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"} /><TextInput name="PUBLISH_RABBITMQ_EXCHANGE" label="Exchange" placeholder="outpost" /><TextInput m={0} name="PUBLISH_RABBITMQ_QUEUE" label="Queue" placeholder="outpost-events" /></Div>}</>}<Button.Permission m={{
          t: 5
        }} primary={true} disabled={!props.dirty || props.isSubmitting} submit={true} icon={props.isSubmitting ? "loading" : "save"}>Save</Button.Permission></Form>;
    };
    $[22] = current_provider;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== t18 || $[25] !== t19 || $[26] !== t20) {
    t21 = <Container medium={true} left={true}><Formik enableReinitialize={true} initialValues={t18} onSubmit={t19}>{t20}</Formik></Container>;
    $[24] = t18;
    $[25] = t19;
    $[26] = t20;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  return t21;
};
export default PublishingSettings;